<template>
    <form>
        <div class="filter-box mx-xl-auto mb-4">
            <div class="filter-input ">
                <p class="mb-0 lab c9">Advanced Filter</p>
                <md-field md-inline class="m-0">
                    <label class="p1n">Search</label>
                    <md-input 
                        id="advanced-search-input"
                        class="px-2 p1n c7" 
                        v-model="form.keyword" 
                        aria-placeholder="Search"/>
                </md-field>
            </div>
            <div class="backers-number mt-3">
                <p class="mb-0 lab c9">Number of Backers</p>
                <a-slider
                    id="backers-slider"
                    range
                    :max="30000"
                    :tooltipVisible="tooltipVisible"
                    :disabled="disabled"
                    v-model="form.backNumRange"/>
                <div class="range-slider d-flex justify-content-between">
                    <p class="mb-0 c3 lab">from</p>
                    <input 
                        id="backers-minimum-spot"
                        v-model="form.backNumRange[0]"
                        class="text-center"
                        type="text">
                    <p class="mb-0 c3 lab">to</p>
                    <input 
                        id="backers-maximum-spot"
                        v-model="form.backNumRange[1]"
                        class="text-center"
                        type="text">
                </div>
            </div>
            <div class="by-category mt-3">
                <p class="mb-0 lab c9">By Category</p>
                <md-field md-inline class="m-0">
                    <md-input
                        id="category-input-advanced"
                        class="c7 p1n"
                        placeholder="Category"
                        v-model="categoryFilter"
                        name="categories">
                            <label>Search Category</label>
                    </md-input>
                </md-field>
                <ul class="categories pl-0 mt-3">
                    <li 
                        class="category-item"
                        :key="category" 
                        v-for="(category, index) in categories.filter(
                            c => c.search(categoryFilter) !== -1
                        ).slice(0, iterator)">
                            <md-checkbox 
                                v-model="form.categories" 
                                :value="category" 
                                :id="`category-checkbox-${index}`"
                                :key="category">
                                    {{category}}
                            </md-checkbox>
                    </li>
                </ul>
                <a 
                    @click.prevent="iterator = 5" 
                    class="p1n c1"
                    id="see-less"   
                    v-if="iterator >= categories.length">
                        Show Less
                </a>
                <a 
                    @click.prevent="seeMoreCategory()" 
                    id="see-more"
                    class="p1n c1"
                    v-else>
                        See More
                </a>
            </div>
            <div class="project-status mt-3">
                <p class="mb-0 lab c9">Project Status</p>
                <ul class="status-list pl-0 mt-3">
                    <li 
                        class="status-item" 
                        v-for="(status,index) in projectStatuses"
                        :key="index">
                            <md-checkbox 
                                v-model="form.statuses" 
                                :value="status" 
                                :id="`status-checkbox-${index}`"
                                :key="status">
                                    {{status}}
                            </md-checkbox>
                    </li>
                </ul>
            </div>
            <button 
                @click="resetSearchRes" 
                id="reset-advanced-search"
                type="button" 
                class="reset p1b c3">
                    Reset
            </button>
        </div>
    </form>
</template>

<script>
import moment from 'moment'
import searchCampaigns from '@/core/_search'
import _ from 'lodash'
import categories, { CATEGORY_KEYWORDS } from './categories'
import projectStatuses from './projectStatuses'
import {mapState} from 'vuex'


const resetForm = () => ({
    backNumRange: [0, 30000],
    updateDates: [new Date(), new Date()],
    tags: [],
    keyword: ' ',
    categories: [],
    statuses: [],
    platforms: ['kickstarter'],
})

export default {
    name: 'SearchFilter',
    data: function () {
        return {
            categoryFilter: '',
            categories,
            projectStatuses,
            tooltipVisible: false,
            disabled: false,
            iterator: 5,
            throttling: null,
            page: 1,
            form: {
                ...resetForm(),
                keyword: this.$route.query.searchText || '',
            },
            dateFormat: 'DD/MM/YYYY',
        }
    },
    computed: {
        ...mapState([
            'total'
        ]),
    },
    watch: {
        'form.keyword': 'onChange',
        'form.updateDates': 'onChange',
        'form.backNumRange': 'onChange',
        'form.platforms': 'onChange',
        'form.categories': 'onChange',
        'form.statuses': 'onChange',
        'form.tags': 'onChange',
        '$route.query.page': 'onFiltersChange',
        '$route.query.searchText': 'updateKeyword'
    },
    mounted: function () {
        if (this.$route.query.filters) {
            try {
                this.form = JSON.parse(this.$route.query.filters)
            } catch {}
        }

        this.$router.replace({
            query: {
                ...this.$route.query,
                page: 1
            }
        }).catch(() => {})

        this.onFiltersChange()
    },
    methods: {
        moment,
        updateKeyword(val) {
            this.form.keyword = val
        },
        onChange: function () {
            if (this.throttling) {
                clearTimeout(this.throttling)
                this.throttling = null
            }

            this.throttling = setTimeout(() => {
                this.$router.replace({ 
                    query: { 
                        ...this.$route.query,
                        page: 1 
                    } }).catch(() => {})
                this.onFiltersChange()
            }, 700)
        },
        onFiltersChange: async function (newVal, oldVal) {

            if(newVal && !oldVal) {
                return
            }

            this.$emit('changeFilters', this.form)

            this.$router.replace({
                query: {
                    ...this.$route.query,
                    filters: JSON.stringify(this.form)
                }
            }).catch(() => {})

            const must = [
                {
                    query_string: {
                        fields: ['title'],
                        // remove all special characters for preventing an Elastic error response
                        query: `*${this.form.keyword.replace(/[^a-zA-Z ]/g, "")}*`,
                    },
                },
                {
                    terms: {
                        platform: this.form.platforms,
                    }
                },
            ]

            if (this.form.statuses.length) {
                const statuses = [...this.form.statuses]
                const index = statuses.indexOf('indemand') 
                if(index !== -1) {
                    must.push({
                        term: {
                            indemand: true
                        }
                    })
                    statuses.splice(index, 1)
                }
                if(statuses.length) {
                    must.push({
                        terms: {
                            state: statuses
                        }
                    })
                }
            }

            if (this.form.categories.length) {
                must.push({
                    terms: {
                        'category.keyword': this.form.categories.reduce(
                            (previous, current) => [
                                ...previous,
                                ...CATEGORY_KEYWORDS[current]
                            ],
                            []
                        )
                    }
                })
            }

            const data = {
                query: {
                    bool: {
                        must,
                        must_not: {
                            exists: {
                                field: 'hidden'
                            }
                        },
                        filter: {
                            range: {
                                // TODO: uncomment when the elastic with give updated_date field
                                // updated_date: {
                                //     gt: this.form.updateDates[0],
                                //     lt: this.form.updateDates[1]
                                // },
                                backers: {
                                    gte: this.form.backNumRange[0],
                                    lte: this.form.backNumRange[1]
                                }
                            }
                        }
                    }
                }
            }

            await searchCampaigns(data, this.$store)

            this.$sendMixpanelEvent('Search', {
                'Search Location': 'Advanced Search',
                'Min Backers Number': this.form.backNumRange[0],
                'Max Backers Number': this.form.backNumRange[1],
                "Keyword": this.form.keyword,
                "Categories": this.form.categories,
                "Statuses": this.form.statuses,
                "Results Count": this.total
            });

            this.$ga.event('Search', 'Advanced Search', `
                MinBackers: ${this.form.backNumRange[0]},
                MaxBackers: ${this.form.backNumRange[1]},
                Keyword: ${this.form.keyword},
                Categories: ${this.form.categories},
                Statuses: ${this.form.statuses},
                ResultsCount: ${this.total}
            `)
        },
        seeMoreCategory() {
            this.iterator += 5
        },
        resetSearchRes() {
            this.form = resetForm()
        },
        onDateChange: function(x) {
            this.form.updateDates[0] = x[0].toDate         
            this.form.updateDates[1] = x[1].toDate           
        }
    },
}
</script>
<style lang="scss" scoped>
    li {
        text-transform: capitalize;
    }
    div.filter-box {
        margin-top: 30px;

        div.filter-input,
        div.update-dates {
            div.datepickers {
                height: 28px;
            }
            div.md-field {

                &::before,
                &::after {
                    display: none;
                }

                &.md-datepicker {
                    min-height: 30px;
                    max-width: 119px !important;

                    i {
                        display: none;
                    }

                    img {
                        position: absolute;
                        left: 100%;
                        top: 50%;
                        transform: translate(-20px, -6px);
                    }

                    button {
                        display: none;
                    }

                    input {
                        width: 100%;
                        height: 30px !important;
                        border: 1px solid #C7C4C4 !important;
                        border-radius: 5px !important;
                        color: #333333;
                        font-size: 13px;
                        padding-left: 5px;

                    }
                }
            }
        }


        div.md-checkbox {
            &.md-checked {
                div.md-checkbox-container {
                    border: 1px solid #0ACF97 !important;
                    background: #0ACF97 !important;

                    &::after {
                        width: 4px !important;
                        height: 8px !important;
                        left: 3px !important;
                    }
                }
            }

            div.md-checkbox-container {
                width: 12px !important;
                min-width: 12px !important;
                height: 12px !important;
                background: #B8CDD7;
                border: 1px solid #8DA0A9 !important;
                box-shadow: inset 0px 10px 40px rgba(0, 0, 0, 0.05) !important;
            }

            label {
                height: 12px !important;
                padding-left: 10px !important;
                line-height: 12px !important;
                font-size: 13px !important;
                color: #333333 !important;
            }
        }

        div.backers-number {
            .ant-slider {
                .ant-slider-handle {
                    background: #727CF5 !important;
                    border-radius: 3px !important;
                    border: 1px solid #727CF5 !important;
                }

                .ant-slider-track {
                    background: #727cf566 !important;
                    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.15);
                    z-index: 3;
                }

                .ant-slider-step {
                    background: #B8CDD7 !important;
                    opacity: 0.9;
                }
            }
        }

        div.by-category {
            div.search_category {
                input {
                    width: 100%;
                    height: 32px;
                    border: 1px solid #C7C4C4;
                    border-radius: 5px;
                    background: transparent;
                    padding-left: 5px;
                }
            }

            ul.categories {
                li.category-item {
                    .md-checkbox {
                        margin: 0 16px 16px 0 !important;
                    }
                }
            }
        }

        div.by-tags {
            div.md-field {
                input {
                    border: 1px solid #C7C4C4;
                    border-radius: 5px;
                    padding-left: 5px;
                    font-size: 13px !important;
                }

                .md-chip {
                    border: 1px solid #9B9B9B !important;
                    border-radius: 5px !important;
                    background: #f4f4f466 !important;
                    color: #333333 !important;
                    font-size: 11px !important;

                    &:hover {
                        color: black;
                    }

                    input {
                        font-size: 13px !important;
                    }
                }

            }
        }
    }
</style>
<style scoped lang="scss">
    div.filter-box {
        width: 230px;

        div.filter-input {
            div.filter-nav {
                height: 50px;

            }

            div.md-field {
                &.md-focused {
                    label {
                        top: 6px;
                        pointer-events: auto;
                        opacity: 1;
                    }
                }

                label {
                    left: 10px;
                    background: #F4F4F4;
                }

                input.md-input {
                    height: 36px;
                    border: 1px solid #C7C4C4;
                    border-radius: 5px;
                }
            }
        }

        div.backers-number {
            .range-slider {
                input {
                    width: 80px;
                    border: 0;
                    border-bottom: 1px solid #C7C4C4;
                    background: transparent;
                    font-size: 13px;
                    font-weight: bold;

                }
            }
            .md-field {
                width: 55px;
                height: 17px;
                min-height: 20px;
                padding-top: 0;
                margin: 0;

                .md-input {
                    font-size: 13px;
                    font-weight: bold;
                    width: 100%;
                    height: 17px;
                }
            }

            .md-checkbox {
                margin-top: 0 !important;
            }

            a {
                &:hover {
                    text-decoration: underline !important;
                }
            }
        }

        button {
            &.reset {
                width: 76px;
                height: 32px;
                border: 1px solid #8DA0A9 !important;
                border-radius: 5px;
                transition: all 0.3s ease;

                &:hover {
                    background: #8DA0A9 !important;
                    color: #FFFFFF !important;
                }
            }
        }
    }

    @media only screen and (min-width: 1400px) and (max-width: 290px) {
        div.filter-box {
            width: 100%;
        }
    }
</style>